import { Button } from 'components';
import {
  handleSave,
  outcomes,
  handleSubmitDisabled,
  // handleSupplierSubmitDisabled,
  handleCheckUniqueness,
  isBeneficiary,
  isAuditor,
  isObjectionCommittee,
  isForeign,
  isMinistry,
  isValidUpdateCarrierUsers
} from 'utils';
import { getLocalString, localNames } from "utils/localisation.service";
import { checkUniqueness } from 'store/forms/actions';
import { useSupplierTypeValidation, useSupplierCarrierUsersValidation } from 'hooks/useSupplierTypeValidation';
import { useSupplierType } from 'hooks/useSupplierType';
import { useEffect } from 'react';

export function RenderButtons({
  task,
  state,
  dispatch,
  saveTask,
  taskId,
  formId,
  setIsVisible,
  setOutcome,
  setCancelModalVisible,
  user,
  viewMode,
  applStatus,
  setVisibleBanner,
  setRejectReasons,
  setInvalidModalVisible,
  locales,
  businessKey
}) {
  const { isDirectSupplier } = useSupplierType();
  const { isValid, logValidation } = useSupplierTypeValidation()
  const { isValidCarrierUsers } = useSupplierCarrierUsersValidation();
  const formKey = task.formKey;
  const isSaved = true;
  const isUserKTP = (user.groups?.filter(a => a.id.startsWith("KTP")).length > 0) ? (user.groups?.filter(a => a.id.startsWith("KTP")).length > 0) : false;
  const foreignSupplier = state.carrier.isForeignSupplier;
  const isForeignSupplier = isForeign(user?.groups) || foreignSupplier;
  const checkUniquenessCreate = state?.checkUniquenessCreate;

  useEffect(() => {
    if (isMinistry(user?.groups)) logValidation()
  }, [state])

  return (
    <div className="app-layout__buttons">
      {
        (!viewMode && (isBeneficiary(user?.groups) || isAuditor(user?.groups) || isObjectionCommittee(user?.groups))) && task.taskName !== "task.name.accepted" &&
        // user.privileges?.includes("CanRenderSaveBtn") && 
        (
          <Button
            type="default"
            id="save"
            className="saveButton"
            label={<strong>{getLocalString(locales, localNames.REQUEST_PAGE_SAVEBUTTON)}</strong>}
            disabled={!isValidCarrierUsers}
            onClick={() => {
              handleSave({
                state,
                dispatch,
                saveTask,
                taskId,
                formId,
                isSaved,
                isForeignSupplier,
              })
              logValidation()
            }}
          />
        )}
      {(!viewMode && isBeneficiary(user?.groups) && task.taskName !== "task.name.accepted" && checkUniquenessCreate?.canCreate && checkUniquenessCreate?.acceptableDate) &&
        // user.privileges?.includes("CanRenderSubmitBtn") && 
        (
          <Button
            type="default"
            id="submit"
            className={"ant-btn-primary submit-btn"}
            label={<strong>{getLocalString(locales, localNames.REQUEST_PAGE_SUBMISSIONBUTTON)}</strong>}
            disabled={
              isForeign(user?.groups) ?
                handleSubmitDisabled({
                  user: { ...user },
                  state: { ...state },
                  formKey,
                }) :
                !isValid
            }
            onClick={() => {
              if (task.taskName !== "task.name.submit_application") {
                setOutcome(
                  isBeneficiary(user?.groups) && task.taskName === "task.name.temporary_rejected" ?
                    outcomes.objectionBeneficiary
                    :
                    outcomes.submitBeneficiary
                );
                setIsVisible(true)
              }
              else {
                if (isForeign(user?.groups)) {
                  setOutcome(outcomes.submitBeneficiary);
                  setIsVisible(true);
                } else {
                  handleCheckUniqueness({
                    user,
                    state,
                    dispatch,
                    isDirectSupplier,
                    checkUniqueness
                  }).then(res => {
                    const reasons = {
                      case: 'submitValidation',
                      acceptable: res.acceptable,
                      responseCode: res.responseCode,
                      checks: res.checks,
                    }

                    if (reasons.acceptable) {
                      setOutcome(outcomes.submitBeneficiary);
                      setIsVisible(true);
                    } else {
                      setRejectReasons(reasons);
                      setInvalidModalVisible(true);
                    }
                  }
                  )
                }
              }
            }}
          />
        )}
      {!viewMode && isAuditor(user?.groups) && !(task.taskName === 'task.name.accepted') &&
        // user.privileges?.includes("CanRenderSubmitBtn") && 
        (
          <Button
            type="default"
            id="submit-reject"
            className={"ant-btn-primary reject-btn"}
            // label={getLocalString(locales,localNames.REQUEST_PAGE_SUBMISSIONBUTTON)}
            label={'Απόρριψη'}
            disabled={viewMode ||
              handleSubmitDisabled({
                user: { ...user },
                state: { ...state },
                formKey,
              })
            }
            onClick={() => {
              setOutcome(outcomes.rejectImplementer);
              setIsVisible(true);
            }}
          />
        )}
      {!viewMode && isAuditor(user?.groups) && !(task.taskName === 'task.name.accepted') &&
        // user.privileges?.includes("CanRenderSubmitBtn") && 
        (
          <Button
            type="default"
            id="submit-approve"
            className={"ant-btn-primary submit-btn"}
            // label={getLocalString(locales,localNames.REQUEST_PAGE_SUBMISSIONBUTTON)}
            label={'Έγκριση'}
            disabled={viewMode ||
              handleSubmitDisabled({
                user: { ...user },
                state: { ...state },
                formKey,
              })
            }
            onClick={() => {
              setOutcome(outcomes.approveImplementer);
              setIsVisible(true);
            }}
          />
        )}
      {!viewMode && isUserKTP && (
        <Button
          type="default"
          className={"ant-btn-primary reject-btn"}
          label={getLocalString(locales, localNames.REQUEST_PAGE_OUTLINE_REJECT)}
          // disabled={
          //   handleSubmitDisabled({
          //   user: { ...user},
          //   state: { ...state },
          //   formKey,
          // })}
          disabled={viewMode}
          //   icon={
          //     <Check width={15} height={15} className={'mr-1'} />
          // }
          onClick={() => {
            setOutcome(outcomes.rejectImplementer);
            setIsVisible(true);
          }
          }
        />
      )}
      {!viewMode && isUserKTP && (
        <Button
          type="default"
          className={"ant-btn-primary submit-btn"}
          label={getLocalString(locales, localNames.REQUEST_PAGE_OUTLINE_APPROVE)}
          // disabled={
          //   handleSubmitDisabled({
          //   user: { ...user},
          //   state: { ...state },
          //   formKey,
          // })}
          disabled={viewMode || isValid}
          //   icon={
          //     <Check width={15} height={15} className={'mr-1'} />
          // }
          onClick={() => {
            setOutcome(outcomes.approveImplementer);
            setIsVisible(true);
          }
          }
        />
      )}
      {!viewMode && isObjectionCommittee(user?.groups) &&
        // user.privileges?.includes("CanRenderSubmitBtn") && 
        (
          <Button
            type="default"
            id="submit-reject"
            className={"ant-btn-primary reject-btn"}
            // label={getLocalString(locales,localNames.REQUEST_PAGE_SUBMISSIONBUTTON)}
            label={'Απόρριψη'}
            disabled={viewMode ||
              handleSubmitDisabled({
                user: { ...user },
                state: { ...state },
                formKey,
              })
            }
            onClick={() => {
              setOutcome(outcomes.rejectObjection);
              setIsVisible(true);
            }}
          />
        )}
      {!viewMode && isObjectionCommittee(user?.groups) &&
        // user.privileges?.includes("CanRenderSubmitBtn") && 
        (
          <Button
            type="default"
            id="submit-approve"
            className={"ant-btn-primary submit-btn"}
            // label={getLocalString(locales,localNames.REQUEST_PAGE_SUBMISSIONBUTTON)}
            label={'Έγκριση'}
            disabled={viewMode ||
              handleSubmitDisabled({
                user: { ...user },
                state: { ...state },
                formKey,
              })
            }
            onClick={() => {
              setOutcome(outcomes.acceptObjection);
              setIsVisible(true);
            }}
          />
        )}
      {/* { !viewMode && isBeneficiary(user?.groups) &&  task.taskName === "task.name.accepted" && isDirectSupplier &&
      // user.privileges?.includes("CanRenderSubmitBtn") && 
      (
        <Button
          type="default"
          id="submit-carrier-users"
          className={"ant-btn-primary submit-btn"}
          // label={getLocalString(locales,localNames.REQUEST_PAGE_SUBMISSIONBUTTON)}
          label={'Ανανέωση Χρηστών'}
          disabled={ 
            isValidUpdateCarrierUsers(state?.carrierUsersStatic,state?.carrier?.carrierUsers,state)
         }
          onClick={() => {
            setOutcome(outcomes.updateCarrierUsers);
            setIsVisible(true);
            }}
        />
      )} */}
    </div>
  );
};
